import { EVENT_PERMISSIONS } from '@/enums/permissions.enum';
import { getOriginEventId } from '@/helpers/event.helper';
import type { GetPermissionsDto } from '@/types/dtos/permissions/response/get-permissions.dto';

/** OSO Event permission string required to assign/remove a given event-level crew role name. */
export function managePermissionForEventCrewRoleName(role: string): string {
  if (role === 'owner') {
    return EVENT_PERMISSIONS.MANAGE_EVENT_OWNERS;
  }
  if (role === 'event_manager') {
    return EVENT_PERMISSIONS.MANAGE_EVENT_MANAGERS;
  }
  return EVENT_PERMISSIONS.MANAGE_EVENT_ROLES;
}

export function eventHasPermission(eventPermissions: string[] | undefined, action: string): boolean {
  return !!eventPermissions?.includes(action);
}

/** Union permissions for origin and current event ids (mode copies can differ). */
export function resolveEventPermissionActions(
  permissions: GetPermissionsDto | undefined,
  event?: { id?: string; origin?: string | { id: string } },
): string[] {
  if (!permissions?.events || !event) {
    return [];
  }

  const originId = getOriginEventId(event);
  const currentId = event.id;
  const merged = new Set<string>();

  for (const id of [originId, currentId]) {
    if (!id) continue;
    for (const action of permissions.events[id] ?? []) {
      merged.add(action);
    }
  }

  return [...merged];
}

/** Event managers may proceed to payment; flow managers may only draft orders. */
export function canCompleteEventOrder(eventPermissions: string[] | undefined): boolean {
  return (
    eventHasPermission(eventPermissions, EVENT_PERMISSIONS.COMPLETE_ORDER) ||
    eventHasPermission(eventPermissions, EVENT_PERMISSIONS.MANAGE_EVENT_ROLES)
  );
}

export function canCreateEventOrder(eventPermissions: string[] | undefined): boolean {
  return eventHasPermission(eventPermissions, EVENT_PERMISSIONS.CREATE_ORDER);
}
